
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFileLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 3.98c0-.541.44-.986.978-.927a9 9 0 1 1-9.925 9.925C1.994 12.44 2.44 12 2.98 12c.542 0 .974.441 1.049.977a7.04 7.04 0 1 0 7.948-7.948C11.441 4.954 11 4.522 11 3.98Z",
  fill: "var(--theme-primary, #9631FF)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M11 3.98029C11 3.43889 11.4402 2.99448 11.9784 3.05333C13.4124 3.21014 14.7928 3.71003 16.0001 4.51677C17.4802 5.50571 18.6337 6.91131 19.3149 8.55585C19.9961 10.2004 20.1743 12.01 19.8271 13.7558C19.4798 15.5016 18.6226 17.1053 17.364 18.364C16.1053 19.6226 14.5016 20.4798 12.7558 20.8271C11.01 21.1743 9.20038 20.9961 7.55585 20.3149C5.91131 19.6337 4.50571 18.4802 3.51677 17.0001C2.71003 15.7928 2.21014 14.4124 2.05333 12.9784C1.99448 12.4402 2.43889 12 2.98029 12C3.52168 12 3.95356 12.441 4.02871 12.9771C4.17526 14.0226 4.55577 15.0262 5.14693 15.9109C5.92043 17.0685 7.01984 17.9708 8.30613 18.5036C9.59241 19.0364 11.0078 19.1758 12.3733 18.9042C13.7388 18.6325 14.9931 17.9621 15.9776 16.9776C16.9621 15.9931 17.6325 14.7388 17.9042 13.3733C18.1758 12.0078 18.0364 10.5924 17.5036 9.30613C16.9708 8.01984 16.0685 6.92043 14.9109 6.14693C14.0262 5.55577 13.0226 5.17526 11.9771 5.02871C11.441 4.95356 11 4.52168 11 3.98029Z\" fill=\"var(--theme-primary, #9631FF)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/file-loading.8bdaab785a9b16c51ac6fd1c5ddf0616.svg"),
        {
          React: SvgFileLoading,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      